export const PRODUCT_PER_PAGE = 50;

// Seasonal "available to ship from" notice shown at the top of the product
// description for every product in the given occasion. Stops rendering by
// itself once shipFrom has passed, so nothing needs reverting after the date.
export const XMAS_SHIPPING_NOTICE = {
  occasionSlug: 'christmas-gift-hampers',
  shipFrom: new Date('2026-10-12T00:00:00+11:00'), // AEDT
  message: 'Available to ship from October 12th 2026',
};
